import * as actions from 'app/actions/session';
import http from 'app/services/http';

export const sessionReducer = (
    state = {
        ip: null,
        session: null,
        secret: null,
        timezone: moment().utcOffset(),
        currentDate: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    },
    action
) => {
    switch (action.type) {
        case 'SESSION_SET_IP': {
            const { value } = action.payload;

            return {
                ...state,
                ip: value,
            };
        }
        case 'SESSION_SET_DATA': {
            const { session } = action.payload;

            return {
                ...state,
                session: session,
            };
        }
        case 'SESSION_CURRENT_DATE': {
            const { datetime } = action.payload;

            return {
                ...state,
                currentDate: datetime,
            };
        }
        case 'SESSION_SET_SECRET': {
            const { secret } = action.payload;

            return {
                ...state,
                secret: secret,
                setupSecret: secret ? state.setupSecret : false,
            };
        }
        case 'SESSION_SET_SETUP_SECRET': {
            const { flag = true } = action.payload;

            return {
                ...state,
                secret: {
                    ...state.secret,
                    setupQrCode: flag,
                },
            };
        }
        default:
            return state;
    }
};

export function sessionGetIp() {
    return async function sessionGetIpThunk(dispatch) {
        const { data } = await http.get('/user/ipinfo');
        return dispatch(actions.setSessionIp(data.ip));
    };
}

export function sessionCheckOut() {
    return async function sessionCheckOutThunk(dispatch) {
        return http
            .post('/user/checkin')
            .then((response) => response.data)
            .catch((response) => response.data)
            .then(({ ip, secret = null, user = null }) => {
                dispatch(actions.setSessionIp(ip));
                dispatch(actions.setSessionSecret(secret));
                dispatch(actions.setSessionData(user));
            });
    };
}

export function sessionSignIn(email, password) {
    return async function sessionSignInThunk(dispatch) {
        return http
            .post('/user/signin', { email, password })
            .then((response) => {
                return response.data;
            })
            .then(({ secret, user = null }) => {
                dispatch(actions.setSessionSecret(secret));
                dispatch(actions.setSessionData(user));
            });
    };
}

export function sessionSetup2Fa() {
    return async function sessionSetup2FaThunk(dispatch) {
        return http.post('/user/setup-2fa').then(() => {
            dispatch(actions.setSessionSetupSecret(true));
        });
    };
}

export function sessionCheck2Fa(code) {
    return async function sessionCheck2FaThunk(dispatch) {
        return http
            .post('/user/check-2fa', { code })
            .then((response) => response.data)
            .then((response) => {
                dispatch(actions.setSessionData(response));
                dispatch(actions.setSessionSecret(null));
            });
    };
}

export function sessionReset2Fa() {
    return async function sessionReset2FaThunk(dispatch) {
        return http.post('/user/reset-2fa').then(() => {
            dispatch(actions.setSessionData(null));
            dispatch(actions.setSessionSecret(null));
        });
    };
}

export function sessionSignOut() {
    return async function sessionSignOutThunk(dispatch) {
        await http.post('/user/signout');
        return dispatch(actions.deleteSessionData());
    };
}

export function sessionResetPassword(email) {
    return async function sessionResetPasswordThunk() {
        await http.post('/user/forgot', { email });
    };
}

export function sessionConfirmResetPassword(code) {
    return async function sessionConfirmResetPasswordThunk() {
        await http.post('/user/forgot/confirm', { code });
    };
}

export function sessionSetResetPassword(password) {
    return async function sessionSetResetPasswordThunk() {
        await http.post('/user/forgot/install', { password });
    };
}

export default sessionReducer;
